const API = process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:8080";

type FeedbackResult = { id: number };

// submitFeedback 提交用户反馈。已登录时自动附带 Bearer token（后端据此填 user_id）。
export async function submitFeedback(
	rating: number,
	content: string,
	pageUrl?: string,
): Promise<FeedbackResult> {
	const token =
		typeof window !== "undefined" ? localStorage.getItem("cg_token") : null;
	const res = await fetch(`${API}/feedback`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			...(token ? { Authorization: `Bearer ${token}` } : {}),
		},
		body: JSON.stringify({
			rating,
			content,
			page_url:
				pageUrl ??
				(typeof window !== "undefined" ? window.location.pathname : ""),
		}),
	});
	if (!res.ok) {
		const d = (await res.json().catch(() => null)) as { error?: string } | null;
		throw new Error(d?.error ?? "提交反馈失败");
	}
	return res.json();
}
